import '@nerdwallet/base-styles/reset.css';
import '@nerdwallet/base-styles/base.css';
import './styles/main.less';

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import initBaseStyles from '@nerdwallet/base-styles/init';
import { initBrowserEvents } from '@nerdwallet/analytics';
import * as Sentry from '@sentry/browser';
import { setSentryClient } from '@nerdwallet/logging';
import { initSentryBrowser } from '@nerdwallet/sentry';

import routes from './routes/index';

initBaseStyles();
initBrowserEvents();
initSentryBrowser();
setSentryClient(Sentry);

export default () => <Router>{routes}</Router>;
